module.exports = __webpack_public_path__ + "img/1-training-technologies@2x.247f4022.png";